import type { TFunction } from 'react-i18next'
import type { TeamMemberInfo } from '~/utils/teams'

export const ENHANCED_SERP_URLS = [
	'stockholm',
	'göteborg',
	'malmö',
	'stockholm/östermalm',
	'stockholm/södermalm',
] as const

export type EnhancedAreaURL = typeof ENHANCED_SERP_URLS[number]
export type OfficeType = 'office' | 'serviced_office' | 'coworking_space'
export type EnhancedSERPContentMap = {
	[key in EnhancedAreaURL]: {
		[key in OfficeType]: {
			title: string
			content: string
		}[]
	}
}
export type EnhancedSERPContentWithExpertMap = {
	[key in EnhancedAreaURL]: {
		[key in OfficeType]: {
			content: {
				heading: string
				text: string
			}
			expert: { info: TeamMemberInfo; text: string }
		}
	}
}
export type EnhancedSERPSubHeadingMap = {
	[key in EnhancedAreaURL]: {
		[key in OfficeType]: string
	}
}
export type AreaURLMap = {
	[key in EnhancedAreaURL]: {
		[key in OfficeType]: { name: string; url: string }[]
	}
}

export function getIsEnhancedSERPUrl(
	url: string | undefined
): url is EnhancedAreaURL {
	if (!url) {
		return false
	}
	return ENHANCED_SERP_URLS.includes(url.toLocaleLowerCase() as EnhancedAreaURL)
}

export function getEnhancedSERPOfficeType(
	pageType: string,
	t: TFunction
): OfficeType | null {
	if (pageType === t('lediga-kontor', { ns: 'url' })) {
		return 'office'
	}
	if (pageType === t('lediga-kontorshotell', { ns: 'url' })) {
		return 'serviced_office'
	}
	if (pageType === t('coworking-spaces', { ns: 'url' })) {
		return 'coworking_space'
	}
	return null
}

export function getOfficeTypeTranslation(
	officeType: OfficeType,
	t: TFunction
): string {
	if (officeType == 'coworking_space') {
		return t('coworking space_other')
	}
	if (officeType == 'serviced_office') {
		return t('kontorshotell_other')
	}
	return t('kontor_other')
}
